import { render } from "./Code2FA.vue?vue&type=template&id=628dab58"
import script from "./Code2FA.vue?vue&type=script&lang=js"
export * from "./Code2FA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__